import React from "react";
import { site } from "../../config/site";

/**
 * When site.comingSoon is true: renders a non-clickable "Coming Soon" style CTA (span).
 * When false: renders external ticket link.
 */
export function TicketLink({ children, className = "", newTab = true, style, ...rest }) {
  if (site.comingSoon) {
    return (
      <span
        aria-disabled="true"
        className={`nsm-coming-soon-cta ${className}`.trim()}
        style={style}
        {...rest}
      >
        {children}
      </span>
    );
  }
  return (
    <a
      href={site.ticketUrl}
      target={newTab ? "_blank" : "_self"}
      rel={newTab ? "noopener noreferrer" : undefined}
      className={className}
      style={style}
      {...rest}
    >
      {children}
    </a>
  );
}

export function openTicket(newTab = true) {
  if (site.comingSoon || typeof window === "undefined") return;
  if (newTab) window.open(site.ticketUrl, "_blank", "noopener");
  else window.location.href = site.ticketUrl;
}
